<template>
	<div class="page_wrap">
		<top></top>
		<div class="home  fs30" id="target_top">
			<div class="header flex bg-ff align-center justify-center">
				<div class="headtit">
				</div>
			</div>
			<!-- 顶部end -->
			<div style="width:22%;margin-left:24%; margin-top:32px">
				<el-tabs stretch type="card" @tab-click="changetab" style="font-size:28px">
					<el-tab-pane v-for="(item, index) in tab_list" :key="index" :label="item.name"></el-tab-pane>
				</el-tabs>
			</div>
			<!-- 主体内容 start -->
			<div class=" flex contain margin-top justify-around ">
				<el-row :gutter="24" class="w100">
					<el-col :span="4" class="tab_box">
						<!-- 热榜 -->
						<div class="hot-box">
							<!-- <div class="flex align-center justify-between">
									<div class="flex align-center">
										<img src="../../assets/image/home/hot.png" class="title-img margin-right-5">
										<span class="title">热榜</span>
									</div>
									<div class="flex align-center point"  @click="changeData">
										<img src="../../assets/image/home/update_red.png" :class="showRotate ? 'loading' : '' "  class="block-24 margin-right-5">
										<span class="change-title">换一换</span>
									</div>
								</div> -->
							<!-- <div class="hot-list margin-top-50">
										<div class="hot-item point margin-bottom-30" v-for="(hot_item,hot_index) in hotLists" :key="hot_index">
											<div class="flex" @click="toArticleDetail(hot_item.aid)">
												<span class="hot-index margin-right-xs" :class="hot_index<3 ? 'text-theme' : 'text-666' ">{{hot_index+1}}</span>
												<span class="hot-title text-cut">{{hot_item.title ||'暂无标题' }}</span>
											</div>
										</div>
								</div> -->
						</div>
					</el-col>
					<el-col :span="15">
						<!-- 中间内容 -->
						<div class="middle-box ">
							<!-- <p class="title">推荐</p> -->
							<!-- 加载中 -->
							<div class="w100" v-if="!isInit">
								<el-skeleton :rows="12" animated />
							</div>
							<!-- 加载有数据 -->
							<div class="w100" v-else>
								<div v-if="lists.length > 0">
									<!-- 动态、文章 -->
									<div class="" v-if="tabIndex == 0 || tabIndex == 1 || tabIndex == 3">
										<div v-for="(item, index) in lists" :key="index">
											<dynamic :is_remind='true' :current='tabIndex + 1' :item="item"></dynamic>
										</div>
									</div>
									<!--电子书 -->
									<el-row :gutter="24" v-if="tabIndex == 2">
										<el-col :span="12" v-for="(item, index) in lists" :key="index">
											<div class="grid-content bg-purple">
												<book-list :item="item"></book-list>
											</div>
										</el-col>
									</el-row>
								</div>
								<div class="" v-if="lists.length == 0">
									<el-empty description="~空空如也~"></el-empty>
								</div>
								<div class="flex align-center  margin-top-30">
									<el-pagination background @size-change="handleSizeChange"
										@current-change="handleCurrentChange" layout="prev, pager, next" :page-size="15"
										:total="totalSize">
									</el-pagination>
								</div>
							</div>
						</div>
					</el-col>
				</el-row>
			</div>
			<!-- 主体内容 end -->
			<!-- 悬浮按钮 -->
			<div class="float-box flex flex-direction align-center justify-around" v-show="scrollTop > 500">
				<img src="../../assets/image/home/top.png" class="block-28" @click="scrollToTop">
				<!-- <img src="../../../assets/image/home/add.png" class="block-19"> -->
				<i class="el-icon-circle-plus-outline fs28" :class="dialogTableVisible ? 'text-e54f' : 'text-333'"
					@click="dialogTableVisible = true"></i>
				<img src="../../assets/image/home/uptade_black.png" class="block-28 point" @click="update"
					:class="showRotate2 ? 'loading' : ''">

			</div>
			<div class="mask" @click="dialogTableVisible = false" v-if="dialogTableVisible"></div>
			<div class="box-content bg-white radius-3  radius-10" v-if="dialogTableVisible">
				<div class="" style="position: relative;">
					<router-link to="/publish">
						<div class="flex align-center padding-tb-20 padding-lr-30 solid-bottom point">
							<img src="../../assets/image/home/add1.png" class="block-24">
							<span class="padding-left-10 fs14">动态</span>
						</div>
					</router-link>
					<div class="flex align-center padding-tb-20 padding-lr-30 solid-bottom point"
						@click="toPublish(1, '/editArticle')">
						<img src="../../assets/image/home/add2.png" class="block-24">
						<span class="padding-left-10 fs14">文章（作家权限）</span>
					</div>
					<div class="flex align-center padding-tb-20 padding-lr-30 point" @click="toPublish(2, '/editBook')">
						<img src="../../assets/image/home/add3.png" class="block-24">
						<span class="padding-left-10 fs14">电子书（作家权限）</span>
					</div>
					<div class="bg-f6f7 height10 w270"> </div>
				</div>
				<div class="padding-tb-15 text-center fs14 text-e54f" @click="dialogTableVisible = false">
					取消
				</div>
			</div>
		</div>
		<bottom></bottom>
	</div>
</template>

<script>
import dynamic from '@/components/dynamic/dynamic';
import bookList from '@/components/book-list/book-list';
import top from '@/components/top';
import bottom from '@/components/bottom';
import loadMore from '@/components/load-more/load-more.vue';
export default {
	components: {
		top,
		bottom,
		dynamic,
		bookList,
		loadMore
	},
	name: 'Home',
	data() {
		return {
			keyword: '', //搜索关键词
			status: 'more',//热榜是否有更多
			showRotate: false, //是否旋转
			showRotate2: false, //是否旋转
			hotLists: [],//热榜
			focusLists: [], //关注列表
			isInit: false,
			page: 1,
			totalSize: 0,//总页数
			loading: false,
			iscompleted: false, //当设置为 true 时将不会再触发 infinite-scroll 事件.当所有数据全部加载完毕后，建议设置为 true
			scrollTop: 0,
			dialogTableVisible: false, //新建弹框
			tabIndex: 1,
			hotSearch: [{
				name: '学生开学了'
			},
			{
				name: '三毛'
			}
			],
			tabLists: [{
				id: 1,
				name: '动态'
			},
			{
				id: 2,
				name: '文章'
			},
			{
				id: 3,
				name: '电子书'
			},
			{
				id: 4,
				name: '付费专栏'
			}
			],
			tab_list: [{
				name: '全部',
				id: ''
			}, {
				name: '日榜',
				id: '1'
			}, {
				name: '周榜',
				id: '2'
			}, {
				name: '月榜',
				id: '3'
			}],
			list_type: '',
			lists: [],
			userData: {}
		}
	},
	computed: {
		// 是否登录状态
		isLogin() {
			return this.$store.getters.isLogin;
		},
		// 是否是作家
		is_writer() {
			return this.$store.getters.is_writer;
		}
	},
	mounted() {
		window.addEventListener('scroll', this.handleScroll);
		this.getHotLists()//获取热榜数据
		this.loadData();
		window['getSonData'] = () => {
			this.loadData();
		};
	},
	destroyed() {
		window.removeEventListener('scroll', this.handleScroll);
	},
	created() {
		this.getUserInfos()
	},
	methods: {
		async getUserInfos() {
			let userinfo = await JSON.parse(localStorage.getItem('USER_INFO'))
			this.ajax('post', '/v1/5c78c4772da97', {
				user_id: userinfo.id
			}, res => {
				if (res.code == 1) {
					this.userData = res.data;
				} else {
					//this.$message.error(res.msg);
				}
			})
		},
		/* 通过code获取openid */
		codeGetOpenid(code) {
			this.ajax('post', '/v1/619714950d880', {
				code: code
			}, res => {
				if (res.code == 1) {
					localStorage.setItem('USER_INFO', JSON.stringify(res.data.userinfo))
					localStorage.setItem('user_token', res.data.userinfo.user_token)
					this.$store.commit('updateUserInfo', res.data.userinfo);
					// window.location.reload();  //刷新页面
				} else if (res.code == -999 && res.data.result) {
					this.$router.push({
						path: '/bind_phone',
						query: {
							openid: res.data.openid,
							unionid: res.data.result.unionid,
							nickName: res.data.result.nickname,
							avatarUrl: res.data.result.headimgurl
						}
					})
				}
			}, err => {
				console.log('微信登录code获取失败', err);
			})
		},
		// 去发布
		async toPublish(type, path) {
			let auditInfo = await this.getAuditInfo();
			// 0  审核中
			// 1  审核通过
			// 2  审核拒绝
			// 3  待支付
			let is_writer = this.userData.is_writer || 0;
			console.log('is_writer', is_writer);
			let info = type == 1 ? '文章' : '电子书';
			switch (auditInfo.status) {
				case -99:
					// if (type == 2) {
					// 	this.$confirm(`只有作家才可以发布${info}哦，去认证?`, '提示', {
					// 		confirmButtonText: '好的',
					// 		type: 'info'
					// 	}).then(() => {
					// 		this.$router.push('/authen')
					// 	}).catch(() => {

					// 	});
					// } else if (type == 1) {
					// 	this.$router.push({
					// 		path: path,
					// 		query: {
					// 			ducoment_type: 2
					// 		}
					// 	})
					// }
					if (is_writer == 0) {
						this.$confirm(`只有作家才可以发布${info}哦，去认证?`, '提示', {
							confirmButtonText: '好的',
							type: 'info'
						}).then(() => {
							this.$router.push('/authen')
						}).catch(() => {

						});
					} else if (is_writer == 1) {
						this.$router.push({
							path: path,
							query: {
								ducoment_type: 2
							}
						})
					}
					break;
				case 0:
					this.$confirm('认证审核中，请耐心等待', '提示', {
						confirmButtonText: '好的',
						type: 'info'
					}).then(() => {

					}).catch(() => {

					});
					break;
				case 1:
					this.$router.push({
						path: path,
						query: {
							ducoment_type: 2
						}
					})
					break;
				case 2:
					let reasons = auditInfo.reason || '暂无原因';
					this.$confirm('认证审核未通过，拒绝原因为：' + reasons + '，请重新提交', '提示', {
						confirmButtonText: '好的',
						cancelButtonText: '不了',
						type: 'info'
					}).then(() => {
						this.$router.push('/authen')
					}).catch(() => {

					});
					break;
				case 3:
					this.$confirm('认证未支付，去支付？', '提示', {
						confirmButtonText: '好的',
						cancelButtonText: '不了',
						type: 'info'
					}).then(() => {
						this.addOrder(auditInfo.period_id, auditInfo.id)
					}).catch(() => {

					});
					break;
				default:
					break;
			}
		},
		// 获取认证信息
		getAuditInfo() {
			return new Promise((resolve, reject) => {
				this.ajax('post', '/v1/6142e36210b86', {}, res => {
					if (res.code == -201) {
						this.$router.push('/login')
					} else {
						resolve(res.data)
					}
				})
			})
		},
		// 统一下单接口
		addOrder(period_id, certified_id) {
			this.ajax('post', '/v1/5d784b976769e', {
				order_type: 4, //1 ：'现金充值'，2：'虚拟币充值'，3 ：'商城交易'，4：认证支付5：打赏6：文章购买
				period_id: period_id,
				certified_id: certified_id
			}, res => {
				if (res.code == 1) {
					let order_sn = res.data.order_sn;
					this.$router.push({
						path: '/payMoney',
						query: {
							order_sn: res.data.order_sn,
							order_money: res.data.money,
							return_url: JSON.stringify(window.location.href)
						}
					})
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		// 动态更新
		update() {
			this.showRotate2 = true;
			setTimeout(() => {
				this.showRotate2 = false
			}, 400);
			this.page = 1;
			this.loadData();
			setTimeout(() => {
				target_top.scrollIntoView();
			}, 400);
		},
		// 页数改变
		handleSizeChange(e) {
			console.log(e);
			this.page = e;
			this.loadData();
			target_top.scrollIntoView();
		},
		// 跳页
		handleCurrentChange(e) {
			console.log(e);
			this.page = e;
			this.loadData();
			target_top.scrollIntoView();
		},
		handleScroll(e) {
			this.scrollTop = e.target.documentElement.scrollTop || e.target.body.scrollTop; // 执行代码
		},
		// tab切换
		tabChange(item, index) {
			if (this.tabIndex == index) return;
			this.tabIndex = index;
			this.isInit = false;
			this.page = 1;
			this.loadData();
			target_top.scrollIntoView();
		},
		// 换一换
		changeData() {
			this.showRotate = true;
			setTimeout(() => {
				this.showRotate = false
			}, 400);
			this.getHotLists()
		},
		// 热榜数据加载
		getHotLists() {
			// if (this.status != "more") return;
			this.ajax('post', '/v1/613b0f6c07cc9', {
				article_type: 2, //1：动态2：文章3：电子书
				index_type: 3,//1：关注2：推荐3：热榜
				page: this.page
			}, res => {
				this.isInit = true;
				if (res.code == 1) {
					this.hotLists = res.data.data.splice(0, 10);
					if (this.page < res.data.last_page) {
						this.status = "more";
						this.page++;
					} else {
						this.page = 1;
						this.status = "noMore";
					}
				} else {
					this.$message.error(res.msg);
				}

			}, err => {
				console.log(err);
				this.hadGotCode = false
			})

		},
		// 发布动态
		publish() {
			this.$router.push('/publishDynac')
		},
		getNews() {
			this.ajax('post', '/common/newsList', {
				cate_id: this.calatId
			}, res => {
				if (res.code == 1) {

					this.newsList = res.data
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		// 显示按钮的显示与隐藏
		scrollToTop() {
			let scrollToptimer = setInterval(function () {
				// console.log("定时循环回到顶部");
				var top = document.body.scrollTop || document.documentElement.scrollTop;
				var speed = top / 4;
				document.documentElement.scrollTop -= speed;
				if (top == 0) {
					clearInterval(scrollToptimer);
				}
			}, 30);
		},
		// 推荐数据加载
		loadData() {
			this.ajax('post', '/v1/637201fddf4b7', {
				list_type: this.list_type,
			}, res => {
				this.isInit = true;
				if (res.code == 1) {
					this.totalSize = res.data.total;
					this.lists = res.data.data;
				} else {
					this.$message.error(res.msg);
				}

			}, err => {
				console.log(err);
				this.hadGotCode = false
			})

		},
		//切换排行榜
		changetab(tab, event) {
			console.log(tab)
			this.list_type = this.tab_list[tab.index].id
			this.loadData()
		},
		// 跳转人才详情
		toDetail(item) {
			this.toBlank({
				path: '/talents_detail',
				query: {
					user_id: item.id
				}
			})
		},
		// 跳转文章详情
		toArticleDetail(aid) {
			this.toBlank({
				path: '/artileDetail',
				query: {
					article_id: aid,
					atype: 2
				}
			})
		},
	}
}
</script>
<style lang="scss" scoped="scoped">
// @import url("./home.css");
.loading {
	-webkit-animation: rotation 0.4s linear;
}

@-webkit-keyframes rotation {
	from {
		-webkit-transform: rotate(0deg);
	}

	to {
		-webkit-transform: rotate(180deg);
	}
}

::-webkit-scrollbar {
	width: 0 !important;
}

::-webkit-scrollbar {
	width: 0 !important;
	height: 0;
}

.tab_box {
	position: sticky;
	top: 80px;
}

.middle-box {
	padding-bottom: 80px;
}

.input-box {
	width: 686px;
	height: 48px;
	background: #FFFFFF;
	opacity: 1;
	border-radius: 24px;

	input {
		width: 80%;
		height: 100%;
		background: #FFFFFF;
		padding: 0 20px;
		border-radius: 24px 0 0 24px;
	}
}

/* 右侧信息 */
.title-img {
	width: 28px;
	height: 28px;
}

.title {
	font-size: 16px;
	font-family: Microsoft YaHei;
	font-weight: bold;
	color: #333333;
	opacity: 1;
}

.change-img {
	width: 16px;
	height: 16px;
}

.box-content {
	position: fixed;
	width: 270px;
	right: 315px;
	bottom: 93px;
	z-index: 1510;
	background-color: #FFFFFF;
}

.change-title {
	font-size: 9px;
	font-family: PingFang SC;
	font-weight: 400;
	line-height: 15px;
	color: #E54F42;
	opacity: 1;
}

.hot-box {
	margin-top: 100px;
}

.hot-list {
	.hot-item {
		.hot-index {
			font-size: 14px;
			font-family: OPPOSans;
			font-weight: bold;
			line-height: 16px;
			opacity: 1;
		}

		.text-theme {
			color: #FE2D46;
		}

		.hot-title {
			font-size: 14px;
			font-family: Microsoft YaHei;
			font-weight: 400;
			line-height: 14px;
			color: #333333;
			opacity: 1;
		}
	}
}

.focus-box {
	.check-box {
		height: 15px;
		font-size: 11px;
		font-family: PingFang SC;
		font-weight: 400;
		line-height: 15px;
		color: #098EF0;
		opacity: 1;
		text-align: right;
		margin-top: 20px;
	}

	.focus-list {
		.focus-item {
			.head-img {
				width: 24px;
				height: 24px;
			}

			.name {
				font-size: 14px;
				font-family: Microsoft YaHei;
				font-weight: 400;
				color: #333333;
				opacity: 1;
			}
		}

	}
}

.float-box {
	position: fixed;
	right: 245px;
	bottom: 138px;
	width: 72px;
	height: 246px;
	background: #FFFFFF;
	box-shadow: 0px 2px 11px rgba(0, 0, 0, 0.08);
	opacity: 1;
	border-radius: 43px;
}

.content {
	margin-left: 19%;
	width: 62%;
}

.headtit {
	width: 100%;
	height: 242px;
	margin-top: 70px;
	text-align: center;
	line-height: 150px;
	background: url('../../assets/image/phb-bg.png') no-repeat;
	background-size: 100% 100%;

	.tits {
		width: 200px;
		height: 30px;
		background: rgb(34, 20, 224);
		color: #fff;
		margin: 0 auto;
		line-height: 30px;
		position: relative;
		top: -30px;
		border-radius: 30px;
	}
}

.bg-ff {
	background: #fff;
}
</style>
